import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "quantity-panel" }
const _hoisted_2 = {
  key: 1,
  class: "quantity-panel__controller"
}
const _hoisted_3 = { class: "quantity-panel__controller-value" }
const _hoisted_4 = ["disabled"]


import IconMinus from '@/icons/icon-minus.vue';
import IconPlus from '@/icons/icon-plus.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuantityPanel',
  props: {
  modelValue: {
    type: Number,
    default: 0,
  },
  max: {
    type: Number,
    default: 99999,
  },
},
  emits: [
  'update:modelValue',
],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.modelValue < 1)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "quantity-panel__add-btn",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('update:modelValue', 1)), ["prevent"]))
        }, "+ " + _toDisplayString(_ctx.$t('toAdd')), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "quantity-panel__controller-btn quantity-panel__controller-btn--remove",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('update:modelValue', __props.modelValue - 1)), ["prevent"]))
          }, [
            _createVNode(IconMinus)
          ]),
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.modelValue), 1),
          _createElementVNode("button", {
            type: "button",
            class: "quantity-panel__controller-btn quantity-panel__controller-btn--add",
            disabled: __props.modelValue >= __props.max,
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('update:modelValue', __props.modelValue + 1)), ["prevent"]))
          }, [
            _createVNode(IconPlus)
          ], 8, _hoisted_4)
        ]))
  ]))
}
}

})